import { defineComponent as _defineComponent } from 'vue'

    const __default__ = {
        model: {
            prop: 'modelValue',
            event: 'update:modelValue',
        },
    };

import { computed, watch } from 'vue';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import { BONUS_MILES_TEXT, hasNonBonusMilesOperators } from '../../lib/filterByBonusMiles';
    import BonusMilesBadge from './BonusMilesBadge.vue';
    import { useViewport } from "@travelata-libs/utils";

    interface BonusMilesFilterProps {
        modelValue: boolean;
        hideTooltip?: boolean;
        selectedOperators?: number[];
    }

    interface BonusMilesFilterEmits {
        (e: 'update:modelValue', value: boolean): void;
    }

    
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BonusMilesFilter',
  props: {
    modelValue: { type: Boolean },
    hideTooltip: { type: Boolean, default: false },
    selectedOperators: { default: () => [] }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'update:modelValue', value: boolean): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, hideTooltip: boolean, selectedOperators: number[] };

    

    

    const { isMobile } = useViewport();

    const isSelected = computed({
        get: () => props.modelValue,
        set: (v: boolean) => emit('update:modelValue', v),
    });

    const isDisabled = computed(() => hasNonBonusMilesOperators(props.selectedOperators));

    watch(
        isDisabled,
        (value) => {
            if (value) emit('update:modelValue', false);
        },
        { immediate: true },
    );

return { __sfc: true,props, emit, isMobile, isSelected, isDisabled, CheckBoxInput, BONUS_MILES_TEXT, BonusMilesBadge }
}

})